<div class="page">
  <div class="page__content">
    <h1 class="header">{{ "step_user_password.title" | translate }}</h1>
    <p>{{ "step_user_password.text" | translate }}</p>
    <form class="form" [formGroup]="userPasswordForm">
      <custom-form-field
        type="email"
        [label]="'step_user_password.field_email' | translate"
        controlName="email"
        [formGroup]="userPasswordForm"
      >
      </custom-form-field>

      <custom-form-field
        type="password"
        [label]="'step_user_password.field_password' | translate"
        controlName="password"
        [formGroup]="userPasswordForm"
        [passwordVisibilitySwitch]="true"
      >
      </custom-form-field>

      <label>
        <custom-checkbox
          formControlName="acceptTermsAndConditions"
        ></custom-checkbox>
        <a
          class="terms-and-conditions"
          [href]="'footer.terms_and_conditions_url' | translate"
          target="”_blank”"
        >
          {{ "step_user_password.terms_and_conditions_label" | translate }}</a
        >
      </label>
    </form>
  </div>
  <div class="page__footer">
    <button
      customButton
      customOnboardingNext
      [disabled]="isLoading || userPasswordForm.invalid"
      expand="full"
      size="large"
      [isLoading]="isLoading"
    >
      {{ "step_user_password.button_next" | translate }}
    </button>
  </div>
</div>
